export class NotificationManager {
    constructor() {
        this.callbacks = new Map();
    }
    registerCallback(name, callback) {
        this.callbacks.set(name, callback);
    }
    executeCallback(callback) {
        if (typeof callback === 'string' || callback instanceof String)
            callback = this.callbacks.get(callback);
        if (callback)
            return callback();
        return null;
    }
    notifyCustom(options) {
        let me = this;
        let swalOptions = SwalEx.getDefaultSwalOptions(options.title, null, options.message, null, options.id, options.buttons);
        swalOptions.allowEscapeKey = options.allowClose;
        swalOptions.allowOutsideClick = options.allowClose;
        swalOptions.willOpen = function () {
            let inputsToValidate = $(`#${options.id}${0}`).closest('#swal2-html-container').find('input');
            inputsToValidate.on('change', function () {
                NotificationManager.enableDisableButtons(options.id, options.buttons, null, options.validate, options.disableNonSubmitButtonsWhenInvalid);
            });
            NotificationManager.enableDisableButtons(options.id, options.buttons, null, options.validate, options.disableNonSubmitButtonsWhenInvalid);
            NotificationManager.registerExecuteCallback(me, options.id, options.buttons, null, options.validate, options.disableNonSubmitButtonsWhenInvalid);
        };
        swalOptions.willClose = function () {
            if (options.onCloseCallbackName != null) {
                me.executeCallback(options.onCloseCallbackName);
            }
        };
        Swal.fire(swalOptions);
    }
    startNotifyCustomOnReady(options) {
        let me = this;
        $(document).ready(function () {
            me.notifyCustom(options);
        });
    }
    static enableButton($button) {
        $button.removeClass('icon-button-disabled');
    }
    static disableButton($button) {
        $button.addClass('icon-button-disabled');
    }
    static enableDisableButtons(buttonIdBase, buttons, inputId, validate, disableNonSubmitButtonsWhenInvalid) {
        if (disableNonSubmitButtonsWhenInvalid == null || disableNonSubmitButtonsWhenInvalid == undefined)
            disableNonSubmitButtonsWhenInvalid = true;
        let isValid = !validate || validate();
        if (isValid === true && inputId) {
            var input = $(`#${inputId}`);
            input.removeClass('error');
            var errorMessage = input.siblings('[data-message]');
            errorMessage.attr('data-message', 'hidden');
        }
        for (var b = 0; b < buttons.length; b++) {
            let $button = $(`#${buttonIdBase + b}`);
            if (validate) {
                if (isValid === true) {
                    if (buttons[b].IsConfirm)
                        NotificationManager.enableButton($button);
                    else if (disableNonSubmitButtonsWhenInvalid)
                        NotificationManager.disableButton($button);
                }
                else if (isValid === false) {
                    if (buttons[b].IsConfirm)
                        NotificationManager.disableButton($button);
                    else if (disableNonSubmitButtonsWhenInvalid)
                        NotificationManager.enableButton($button);
                }
                else {
                    if (buttons[b].IsConfirm)
                        NotificationManager.disableButton($button);
                    else if (disableNonSubmitButtonsWhenInvalid)
                        NotificationManager.disableButton($button);
                }
            }
            else {
                $button.removeClass('icon-button-disabled');
            }
        }
    }
    static registerExecuteCallback(me, buttonIdBase, buttons, inputId, validate, disableNonSubmitButtonsWhenInvalid) {
        if (disableNonSubmitButtonsWhenInvalid == null || disableNonSubmitButtonsWhenInvalid == undefined)
            disableNonSubmitButtonsWhenInvalid = true;
        for (var b = 0; b < buttons.length; b++) {
            $('#' + buttonIdBase + b).on('click', function () {
                let isValid = !validate || validate();
                let button = buttons[+this.id.slice(-1)];
                if (button.IsConfirm) {
                    if (!validate || isValid === true) {
                        Swal.close();
                        me.executeCallback(button.Callback);
                    }
                    else {
                        if (inputId) {
                            var input = $('#' + inputId);
                            input.addClass('error');
                            input.focus();
                            var errorMessage = input.siblings('[data-message]');
                            errorMessage.attr('data-message', 'error');
                        }
                    }
                }
                else {
                    if (validate && isValid !== false && disableNonSubmitButtonsWhenInvalid) {
                        return;
                    }
                    Swal.close();
                    me.executeCallback(button.Callback);
                }
            });
        }
    }
    toastCustom(options) {
        let me = this;
        if (options.cssIconClass === null || options.cssIconClass === undefined) {
            options.cssIconClass = NotificationManager.InfoCssIcon;
        }
        if (options.timer === null)
            options.timer = undefined;
        Swal.fire({
            position: 'bottom-end',
            html: '<div onclick="Swal.close(); event.stopPropagation();" style="display:flex; align-items: center;"><div style="padding-right: 1em; display:flex; flex-direction: column; justify-content: center;"><i class="fal fa-4x ' + options.cssIconClass + '"></i></div>' + '<div>' + options.message + '</div></div>',
            showCancelButton: false,
            showConfirmButton: false,
            showClass: {
                popup: 'swal2-show',
                backdrop: 'swal2-backdrop-show',
                icon: 'swal2-icon-show'
            },
            hideClass: {
                popup: 'swal2-hide',
                backdrop: 'swal2-backdrop-hide',
                icon: 'swal2-icon-hide'
            },
            toast: true,
            showCloseButton: true,
            timer: options.timer,
            willClose: function () {
                if (options.onCloseCallbackName != null) {
                    me.executeCallback(options.onCloseCallbackName);
                }
            }
        });
    }
    startToastOnReady(message, cssIconClass, delay = 500) {
        let me = this;
        let callback = () => me.toastCustom({
            message: message,
            onCloseCallbackName: null,
            cssIconClass: cssIconClass,
            timer: null
        });
        $(document).ready(() => {
            if (!window.performance ||
                !window.performance.navigation ||
                window.performance.navigation.type !== window.performance.navigation.TYPE_BACK_FORWARD) {
                window.setTimeout(callback, delay);
            }
        });
    }
    startToastOnModalClose(dialogId, onModalCloseToastMessageAttributeName, cssIconClass, cssIconClassAdditionAttributeName = null, delay = 500) {
        let me = this;
        $('#' + dialogId).on('hidden.bs.modal', () => {
            let message = parent.window.document.body.getAttribute(onModalCloseToastMessageAttributeName);
            parent.window.document.body.setAttribute(onModalCloseToastMessageAttributeName, '');
            if (cssIconClassAdditionAttributeName) {
                let cssIconClassAddition = parent.window.document.body.getAttribute(cssIconClassAdditionAttributeName);
                parent.window.document.body.setAttribute(cssIconClassAdditionAttributeName, '');
                cssIconClass = (cssIconClass ?? '') + ' ' + cssIconClassAddition;
            }
            if (message && message.length > 0) {
                if (!window.performance ||
                    !window.performance.navigation ||
                    window.performance.navigation.type !== window.performance.navigation.TYPE_BACK_FORWARD) {
                    window.setTimeout(() => me.toastCustom({
                        message: message,
                        onCloseCallbackName: null,
                        cssIconClass: cssIconClass,
                        timer: null
                    }), delay);
                }
            }
        });
    }
    static validateInput(inputId, inputRegEx) {
        var value = $(`#${inputId}`).val();
        var regex = new RegExp(inputRegEx, 'g');
        let isValid = value != null && value != undefined && value.length > 0 && (!inputRegEx || regex.test(value));
        if (!isValid && value != null && value != undefined && value.length > 0)
            isValid = null;
        return isValid;
    }
    requireUserInput(options) {
        if (!options.inputId)
            options.inputId = 'userInput' + Math.floor(Math.random() * 10000);
        let buttonIdBase = options.inputId + '_button_';
        let input = SwalEx.createInput(options.inputId, options.errorMessage, options.maxLength, options.inputPrefix);
        if (!options.callbackExecutor)
            options.callbackExecutor = this;
        let swalOptions = SwalEx.getDefaultSwalOptions(options.title, null, options.message, input, buttonIdBase, options.buttons);
        swalOptions.allowEscapeKey = options.allowClose;
        swalOptions.allowOutsideClick = options.allowClose;
        if (options.isRedTitle && swalOptions.customClass)
            swalOptions.customClass.title = (swalOptions.customClass.title ?? '') + ' danger-color';
        swalOptions.willOpen = function () {
            $('#' + options.inputId).on('keyup', function (event) {
                if (event.which === 13 || event.keyCode === 13) {
                    for (var b = 0; b < options.buttons.length; b++) {
                        if (options.buttons[b].IsConfirm) {
                            $('#' + buttonIdBase + b).click();
                            return;
                        }
                    }
                }
            });
            let validate = function () { return NotificationManager.validateInput(options.inputId, options.inputRegEx); };
            $('#' + options.inputId).on('keyup', function () {
                NotificationManager.enableDisableButtons(buttonIdBase, options.buttons, options.inputId, validate, options.disableNonSubmitButtonsWhenInvalid);
            });
            NotificationManager.enableDisableButtons(buttonIdBase, options.buttons, options.inputId, validate, options.disableNonSubmitButtonsWhenInvalid);
            NotificationManager.registerExecuteCallback(options.callbackExecutor, buttonIdBase, options.buttons, options.inputId, validate, options.disableNonSubmitButtonsWhenInvalid);
        };
        if (options.onCloseCallbackName) {
            swalOptions.willClose = function () {
                options.callbackExecutor.executeCallback(options.onCloseCallbackName);
            };
        }
        Swal.fire(swalOptions);
    }
    ;
}
NotificationManager.SuccessCssIcon = 'fal fa-square-check status-success';
NotificationManager.InfoCssIcon = 'fal fa-info-square';
NotificationManager.WarningCssIcon = 'fal fa-triangle-exclamation status-warning';
NotificationManager.ErrorCssIcon = 'fal fa-square-xmark status-error';
export class NotificationOptionsBase {
    constructor() {
        this.disableNonSubmitButtonsWhenInvalid = true;
    }
}
export class NotifyCustomOptions extends NotificationOptionsBase {
}
export class UserInputOptions extends NotificationOptionsBase {
}
export class ToastOptions {
    constructor() {
        this.timer = undefined;
    }
}
window.NotificationManager = NotificationManager;
